// Authentication Pages

export default [
    /*template*/
    {
        params: {
            path: "/template_setting/templates",
            name: "template_setting/Templates",
        },
        defaultComponentPath: "Pages/template_setting/Templates",
        navs: true,
    },
    {
        params: {
            name: "EditTemplate",
            path: "/template_setting/templates/edit_template/:id",
        },
        defaultComponentPath: "Pages/template/EditTemplate",
        navs: true,
    },
    {
        params: {
            name: "AddFontTemplate",
            path: "/template_setting/templates/add_font_template/:id",
        },
        defaultComponentPath: "Pages/template/AddFont",
        navs: true,
    },
    {
        params: {
            name: "AddTemplate",
            path: "/template_setting/templates/add_template",
        },
        defaultComponentPath: "Pages/template/AddTemplate",
        navs: true,
    },
    /*Templates_Size */
    {
        params: {
            path: "/template_setting/template_size",
            name: "template_setting/Templates_Size",
        },
        defaultComponentPath: "Pages/template_setting/Template_Size",
        navs: true,
    },
    /*Templates_Type */
    {
        params: {
            path: "/template_setting/template_type",
            name: "template_setting/Templates_Type",
        },
        defaultComponentPath: "Pages/template_setting/Templates_Type",
        navs: true,
    },
    /*Bundle*/
    {
        params: {
            path: "/template_setting/bundle",
            name: "template_setting/Bundle",
        },
        defaultComponentPath: "Pages/template_setting/Bundle",
        navs: true,
    },
    {
        params: {
            path: "/template_setting/bundle/add_bundle",
            name: "bundle/AddBundle",
        },
        defaultComponentPath: "Pages/bundle/AddBundle",
        navs: true,
    },
    {
        params: {
            path: "/template_setting/bundle/edit_bundle/:id",
            name: "bundle/EditBundle",
        },
        defaultComponentPath: "Pages/bundle/EditBundle",
        navs: true,
    },
    //theme
    {
        params: {
            path: "/template_setting/themes",
            name: "template_setting/Themes",
        },
        defaultComponentPath: "Pages/template_setting/Themes",
        navs: true,
    },
    /*tag*/
    {
        params: {
            path: "/template_setting/tags",
            name: "template_setting/Tags",
        },
        defaultComponentPath: "Pages/template_setting/Tags",
        navs: true,
    },
    /*Font*/
    {
        params: {
            path: "/template_setting/fonts",
            name: "template_setting/Fonts",
        },
        defaultComponentPath: "Pages/template_setting/Fonts",
        navs: true,
    },
    /*customer*/
    {
        params: {
            name: "Customers",
            path: "/customers",
        },
        defaultComponentPath: "Pages/Customers",
        navs: true,
    },

    /*order*/
    {
        params: {
            name: "Orders",
            path: "/orders",
        },
        defaultComponentPath: "Pages/Orders",
        navs: true,
    },
    {
        params: {
            name: "OrderDetail",
            path: "/orders/order_detail/:id",
        },
        defaultComponentPath: "Pages/order/OrderDetail",
        navs: true,
    },
    /*custom desgin setting*/
    {
        params: {
            name: "custom_design_setting",
            path: "/custom_design_setting",
        },
        defaultComponentPath: "Pages/CustomTemplateSetting",
        navs: true,
    },
    /*payment*/
    {
        params: {
            name: "Payments",
            path: "/payments",
        },
        defaultComponentPath: "Pages/Payments",
        navs: true,
    },
    /*user*/
    {
        params: {
            name: "Users",
            path: "/users",
        },
        defaultComponentPath: "Pages/Users",
        navs: true,
    },
    {
        params: {
            name: "EditUser",
            path: "/users/:id",
        },
        defaultComponentPath: "Pages/user/EditUser",
        navs: true,
    },
    {
        params: {
            name: "login",
            path: "/login",
            meta: {layout: "full"},
        },
        defaultComponentPath: "Pages/auth/login"
    },

//delete cache
    {
        params: {
            path: "/delete_cache",
            name: "DeleteCache",
        },
        defaultComponentPath: "Pages/DeleteCache",
        navs: true,
    },
    {
        params: {
            path: "*",
            name: "PageNotFound",
            meta: {layout: "full"},
        },
        defaultComponentPath: "Pages/Errors/Error404",
    },
];
